/**
 * Lookup a value in the cache.
 * If it doesn't exist or is expired, load it based on the loadCallback.
 * @param {String} key
 * @param {Function} loadCallback
 */
exports.lookup = async (key, loadCallback) => {
  const cacheKey = `lookup:${key}`;
  const cache = localStorage.getItem(cacheKey);

  if (cache) {
    const { data, expires } = JSON.parse(cache);

    if (Date.now() < expires) return data;
  }

  const data = await loadCallback();

  if (!data || (Array.isArray(data) && data.length === 0)) return data;

  localStorage.setItem(
    cacheKey,
    JSON.stringify({ data, expires: Date.now() + 1000 * 60 * 60 * 24 })
  );

  return data;
};

exports.clear = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith('lookup:')) {
      localStorage.removeItem(key);
    }
  }
};
